import { ButtonReset } from "../partials/buttons";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

export default {
  container: {
    ...ButtonReset,
    marginLeft: "auto",
    marginRight: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "& span": {
      display: "inline-block",
      marginLeft: "5px",
    },
    "& svg path:not(.white)": {
      fill: stylesConfig.colors.secondary.spectrum500,
    },
    [mediaQuery.hover]: {
      "&:hover svg path:not(.white)": {
        fill: stylesConfig.colors.secondary.spectrum800,
      },
    },
  },
};
